import React, { useEffect } from 'react';
import { MEGA_MENU_ITEMS } from '../../constants/navigation.constants';
import { getIconSrc } from '../../constants/iconMap';
import { NavigationItem } from '../../types/header.types';
import { track } from '../../../../services/analytics';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  searchProps?: {
    value: string;
    onChange: (value: string) => void;
    onSearch: (term: string) => void;
  };
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, searchProps }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    };
  }, [isOpen]);

  const renderMobileMenuItem = (item: NavigationItem) => {
    const iconSrc = getIconSrc(item.icon);

    return (
      <div key={item.id} className="box-menu">
        <div className="title">
          {item.href ? (
            <a 
              href={item.href} 
              className="d-flex align-items-center"
              target={item.external ? '_blank' : undefined}
              rel={item.external ? 'noopener noreferrer' : undefined}
              onClick={() => {
                if (item.id === 'forluzgo') {
                  track('link_externo_clique', {
                    identificador: item.id,
                    categoria: 'produto_forluz',
                  });
                }
                setTimeout(() => onClose(), 150);
              }}
            >
              {iconSrc && (
                <img 
                  src={iconSrc} 
                  alt={item.label} 
                  width="20" 
                  height="18" 
                  onError={(e) => {
                    console.warn(`Erro ao carregar ícone: ${item.icon}`);
                    e.currentTarget.style.display = 'none';
                  }}
                />
              )}
              <span>{item.label}</span>
            </a>
          ) : (
            <span className="d-flex align-items-center">
              {iconSrc && (
                <img 
                  src={iconSrc} 
                  alt={item.label} 
                  width="20" 
                  height="18" 
                  onError={(e) => {
                    console.warn(`Erro ao carregar ícone: ${item.icon}`);
                    e.currentTarget.style.display = 'none';
                  }}
                />
              )}
              <span>{item.label}</span>
            </span>
          )}
        </div>
        {item.children && (
          <ul>
            {item.children.map(child => (
              <li key={child.id}>
                <a 
                  href={child.href}
                  target={child.external ? '_blank' : undefined}
                  rel={child.external ? 'noopener noreferrer' : undefined}
                  onClick={() => {
                    setTimeout(() => onClose(), 150);
                  }}
                >
                  {child.label}
                </a>
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

  // Handler para fechar ao clicar no overlay
  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Handler para fechar com ESC
  useEffect(() => {
    const handleEscKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  return (
    <>
      {/* MOBILE MENU - IGUAL AOS HTMLs ESTÁTICOS */}
      <div className={`_nav-menu ${isOpen ? 'active' : ''}`}>
        <div className="_nav-menu-topo">

          <div className="topo-header">
            <div className="logo">
              <a href="/" onClick={onClose}>
                <img 
                  src={getIconSrc('logo-forluz-texte.svg')}
                  alt="Logo" 
                />
              </a>
            </div>
            <button 
              className="btn-close-mobile"
              onClick={onClose}
              aria-label="Fechar menu"
            >
              <img
                src={getIconSrc('close.svg')}
                alt="Fechar"
                width="18"
                height="18"
              />
            </button>
          </div>

          {/* Área do participante */}
          <a 
            href="https://participante.forluz.org.br/" 
            className="btn btn-outline-white btn-icon btn-menu rounded transition py-2 px-4 w-100 text-left btn-100 open-login"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              track('home_menu_clique', {
                identificador: 'area_participante',
                tipo_destino: 'url',
              });
              setTimeout(() => onClose(), 150);
            }}
          >
            <img 
              src={getIconSrc('AreaDoParticipante.svg')} 
              alt="Área do participante" 
              width="24" 
              height="24" 
              className="mr-3" 
            />
            <span>Área do participante</span>
          </a>

          {/* Campo de busca */}
          <div className="header__busca rounded mt-4">
            <form action="/resultado-busca" method="get">
              <button type="submit" className="btn-busca">
                <img 
                  src={getIconSrc('lupa.svg')} 
                  alt="Buscar" 
                  width="16" 
                  height="16" 
                  className="mr-1 ml-1" 
                />
              </button>
              <input 
                type="text" 
                name="s-mobile" 
                id="s-mobile" 
                placeholder="O que você procura?" 
                required 
                value={searchProps?.value || ''}
                onChange={(e) => searchProps?.onChange?.(e.target.value)}
              />
            </form>
          </div>
        </div>

        {/* Lista do menu */}
        <div className="_nav-menu-list py-6">
          {MEGA_MENU_ITEMS.map(item => renderMobileMenuItem(item))}
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
